import { render, staticRenderFns } from "./AllocationType.vue?vue&type=template&id=004c5bcb&"
import script from "./AllocationType.vue?vue&type=script&lang=ts&"
export * from "./AllocationType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports